<div class="drawer-container">
  <div
    class="drawer"
    [class.open]="isDrawerOpen()"
    [style.maxWidth.px]="maxContentWidth"
  >
    <div class="nav-section">
      <div
        class="logo-container"
        [style.maxWidth]="isDrawerOpen() ? '100%' : '54px'"
      >
        <img
          *ngIf="!showSmallLogo"
          [src]="smallLogo"
          class="header-logo"
          (click)="isDrawerOpen.set(true)"
        />
        <img
          *ngIf="showSmallLogo"
          [src]="largeLogo"
          class="header-logo"
          (click)="isDrawerOpen.set(false)"
        />
      </div>

      <div #drawerItemList class="drawer-item-list">
        @for (nav of sideNavHeadings; track $index) {
        <ng-container
          *ngTemplateOutlet="drawerItemTemplate; context: { item: nav }"
        ></ng-container>
        }
      </div>
    </div>
    <div class="nav-section">
      <div #drawerItemList class="drawer-item-list">
        @for (nav of bottomSideNavHeadings; track $index) {
        <ng-container
          *ngTemplateOutlet="drawerItemTemplate; context: { item: nav }"
        ></ng-container>
        }
      </div>
      <div style="padding: 0px 8px; color: var(--color-grey-800)">
        {{ version }}
      </div>
    </div>
  </div>
  <div
    class="submenu-panel"
    *ngIf="activeSubMenu"
    [style.left.px]="maxContentWidth"
  >
    <ng-container *ngFor="let subItem of activeSubMenu">
      <a
        class="drawer-item"
        [routerLink]="subItem.link"
        [class.active]="subItem.id === activatedSubMenuItem"
        [style.justifyContent]="'start'"
        (click)="onDrawerItemClick(subItem, false)"
        style="text-decoration: none"
      >
        <span class="submenu-item-text" [attr.data-text]="subItem.text">
          {{ subItem.text }}
        </span>
      </a>
    </ng-container>
  </div>

  <div class="drawer-content">
    <ng-content></ng-content>
  </div>
</div>

<ng-template #drawerItemTemplate let-item="item">
  <a
    class="drawer-item"
    [routerLink]="item.link"
    [class.active]="item.id === activatedMenuItem"
    [style.justifyContent]="showText ? 'start' : 'center'"
    (click)="onDrawerItemClick(item, true)"
    style="text-decoration: none"
  >
    <div class="drawer-item-icon">
      <app-svg-icon
        *ngIf="item.icon"
        [icon]="item.icon"
        [size]="22"
        [strokeWidth]="1.5"
        class="icon"
      ></app-svg-icon>
    </div>
    <span *ngIf="showText" class="drawer-item-text">{{ item.text }}</span>
  </a>
</ng-template>
